import React,{useState, useEffect} from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper/modules";

const SALONAPI = process.env.REACT_APP_SOMPROP_API_EXTERNAL;

const MainBanner = () => {

  const [data, setData] = useState(null);
  const [loadinglist, setLoadinglist] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${SALONAPI}/ipadGalleryData`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setData(result);
      } catch (error) {
        setError(error);
      } finally {
        setLoadinglist(false);
      }
    };

    fetchData();
  }, []); 

  if (loadinglist) return <div className="shimmer-main"><div className="shimmer" style={{height:'729px', display:'block'}}></div></div>;
  if (error) return <div>Error: {error.message}</div>;


  return (

   <div className="main-banner" style={{minHeight:'730px'}}>

    {
        data && ( <Swiper 
          spaceBetween={30}
          effect={"fade"}
          navigation={false}
          modules={[Autoplay, EffectFade, Navigation, Pagination]}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          className="mySwiper"
        >
          {
            data && data.map((gallery, index) => (
              <SwiperSlide key={gallery.gallery_category_id}>
              <div className="banner-img">

              <img style={{minHeight:'730px'}}
                  src={gallery.gallery_category_attachment} width="100%" height='730'
                  alt={'Gallery'+index}
                />
              </div>
            </SwiperSlide>
            ))
          }
         
          
        </Swiper>)
    }
     
      <div className="arrow-chevron">
        <a href="#parallax">
          <span className="chevron down"></span>
        </a>
      </div>
    </div>
    
  );
};

export default MainBanner;
